import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// ✅ IMPORTS DE REDUCERS
import { userReducer } from './slices/userSlice';
import { businessReducer } from './slices/businessSlice';

// ✅ CONFIGURACIÓN DE PERSISTENCIA
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'business'], // Solo persistir estos slices
  // ✅ CONFIGURACIONES ADICIONALES DE PERSISTENCIA
  serialize: true,
  deserialize: true,
};

// ✅ COMBINACIÓN DE REDUCERS
const rootReducer = combineReducers({
  user: userReducer,
  business: businessReducer,
  // ✅ AGREGAR NUEVOS REDUCERS AQUÍ
  // example: exampleReducer,
});

// ✅ PERSISTENCIA DEL ROOT REDUCER
const persistedRootReducer = persistReducer(persistConfig, rootReducer);

// ✅ CONFIGURACIÓN DEL STORE
export const store = configureStore({
  reducer: persistedRootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // ✅ IGNORAR ACCIONES DE PERSISTENCIA
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        // ✅ IGNORAR PATHS ESPECÍFICOS SI ES NECESARIO
        // ignoredPaths: ['user.token'],
        warnAfter: 128,
      },
      // ✅ CONFIGURACIONES ADICIONALES DE MIDDLEWARE
      immutableCheck: {
        warnAfter: 128,
      },
    }),
  // ✅ CONFIGURACIONES ADICIONALES DEL STORE
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: undefined,
});

// ✅ TIPOS EXPORTADOS
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// ✅ HOOKS TYPED (OPCIONAL, PARA MEJOR TYPING)
export type AppStore = typeof store;
